module.exports = __webpack_public_path__ + "img/thumbnail_LionTailedMacaque_j_normal.366f613a.png";